/* * @Author: 曹俊杰 * @Date: 2023-01-11 15:07:27 * @Module: 企业认证 */
<template>
  <div class="CompanyAuth">
    <div class="daohang">
      <div class="daohang_l">
        <div class="l_1">企业认证</div>
        <div class="l_2">/</div>
        <div class="l_3">填写企业信息</div>
      </div>
      <div class="daohang_r">完成个人实名后，可进行企业认证</div>
    </div>
    <div class="top">
      <img src="@/assets/image/icon_3.png" alt="" srcset="" />
      <p>中能E签保证您的信息安全，信息仅用于身份验证</p>
    </div>

    <div class="content">
      <div class="step1" v-show="step === 1">
        <div class="title">
          <i
            class="el-icon-ali-qiyerenzheng"
            style="color: #0062ff; margin-right: 6px"
          ></i>
          <span>填写认证信息</span>
        </div>
        <div class="titleDesc" v-show="titleDescType">
          应电子签名相关法律要求，请补充企业统一社会信用代码等信息<br />
          您也可<span style="color: #0062ff" @click="titleDescType = 0">手动填写</span>
          企业信息
        </div>
        <div class="titleDesc" v-show="!titleDescType">
          应电子签名相关法律要求，请补充企业统一社会信用代码等信息<br />
          您也可<span @click="titleDescType = 1" style="color: #0062ff"
            >上传营业执照快速识别</span
          >
          企业信息
        </div>
        <el-form
          ref="form"
          label-position="top"
          :model="form"
          label-width="140px"
          :rules="rules"
          size="medium"
        >
          <el-form-item label="上传营业执照" v-show="titleDescType">
            <el-upload
              action=""
              :auto-upload="false"
              accept="image/*"
              drag
              :show-file-list="false"
              :on-change="onChange"
            >
              <div class="CompanyAuth"></div>
            </el-upload>
          </el-form-item>
          <el-form-item label="公司名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入您的公司名"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="idNumber">
            <el-input
              v-model="form.idNumber"
              placeholder="请输入您的统一社会信用代码"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人代表姓名" prop="representativeName">
            <el-input
              v-model="form.representativeName"
              placeholder="请输入您的法人代表姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人代表证件类型" prop="representativeIdType">
            <el-select
              v-model="form.representativeIdType"
              style="width: 100%"
              placeholder="选择您的法人代表证件类型"
            >
              <el-option
                v-for="item in idType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <el-input v-model="form.representativeIdType" placeholder="选择您的法人代表证件类型"></el-input> -->
          </el-form-item>
          <el-form-item label="法人代表证件号" prop="representativeIdNumber">
            <el-input
              v-model="form.representativeIdNumber"
              placeholder="请输入您的法人代表证件号"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人代表手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入法人代表手机号"></el-input>
          </el-form-item>
          <el-form-item label="邀请码" prop="inviteCode" v-show="showinviteCode">
            <el-input v-model="form.inviteCode" placeholder="请输入邀请码"></el-input>
          </el-form-item>
        </el-form>

        <div class="btns">
          <el-button class="btn" type="primary" plain @click="tohome">返回</el-button>
          <el-button
            class="btn"
            type="primary"
            :loading="loading"
            :disabled="loading || !!pollTimer"
            @click="submitForm"
          >
            提交
          </el-button>
        </div>
      </div>

      <div class="step3" v-show="step === 3">
        <div class="step3_icon">
          <img src="@/assets/image/success.png" alt="" srcset="" />
          <div class="step3_icon_title">认证成功</div>
          <div class="step3_icon_desc">恭喜您企业实名认证成功</div>
        </div>

        <div class="btns" style="margin-top: 40px">
          <el-button
            class="button"
            type="primary"
            @click="$router.push({ name: 'home' })"
          >
            回到首页
          </el-button>
        </div>
      </div>
    </div>
    <qrDialog ref="qrDialog" @close="close">
      <span class="text">
        <span>使用</span>
        <span>「微信账号」<span style="color: #666666">或</span>「支付宝账号」</span>
        <span>使用扫码完成签署</span>
      </span>
    </qrDialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import selectData from "@/mixins/selectData.js";
import uploadFile from "@/utils/oss.js"; // 引入oss.js文件
import qrDialog from "@/components/qrDialog.vue";
export default {
  components: {
    qrDialog,
  },
  mixins: [selectData],
  data() {
    return {
      step: 1,
      loading: false,
      pollTimer: null,
      pollSession: 0,
      pageDisposed: false,
      showinviteCode: true,
      form: {
        name: "",
        idNumber: "",
        representativeName: "",
        representativeIdNumber: "",
        phone: "",
        inviteCode: "",
        representativeIdType: "",
      },
      titleDescType: 0,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
    rules() {
      const phoneValidator = (_, value, callback) => {
        if (!value) {
          return callback(new Error("手机号不能为空"));
        }
        if (this.$utils.test.mobile(value)) {
          return callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      };
      const rulesSetting = {
        idNumber: [
          { required: true, trigger: "blur", validator: this.idNumberValidator },
        ],
        representativeName: [
          { required: true, message: "法人代表姓名不能为空", trigger: "blur" },
        ],
        representativeIdNumber: [
          { required: true, message: "法人代表证件号不能为空", trigger: "blur" },
        ],
        name: [{ required: true, message: "公司名不能为空", trigger: "blur" }],
        representativeIdType: [
          { required: true, message: "证件类型不能为空", trigger: "blur" },
        ],
        phone: [{ required: true, validator: phoneValidator, trigger: "blur" }],
      };
      if (this.showinviteCode) {
        return {
          ...rulesSetting,
          inviteCode: [{ required: true, message: "邀请码不能为空", trigger: "blur" }],
        };
      } else {
        return rulesSetting;
      }
    },
  },
  mounted() {
    const query = this.$route.query || {};
    this.form = {
      ...this.form,
      ...query,
    };
  },
  beforeDestroy() {
    this.pageDisposed = true;
    this.stopPolling();
  },
  methods: {
    ...mapActions("app", ["setServicepopupvisible"]),
    tohome() {
      this.$store.dispatch("user/getAccount");
      this.$router.push({ name: "home" });
    },
    idNumberValidator(_, value, callback) {
      if (!value) {
        return callback(new Error("统一社会信用代码不能为空"));
      }
      if (!this.$utils.test.checkSocialCreditCode(value)) {
        return callback(new Error("请检查统一社会信用代码是否正确"));
      }
      this.getCompanyVerify(value);
      callback();
    },
    async getCompanyVerify(idNumber) {
      // const { data, status } = await this.$api.getCompanyVerify({ idNumber });
      // if (status !== 200) {
      //   return;
      // }
      // if (data.exist) {
      //   this.showinviteCode = false;
      //   return;
      // }
      // this.showinviteCode = true;
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postAccountAuth();
        } else {
          return false;
        }
      });
    },
    showQR(data) {
      this.stopPolling();
      const pollSession = this.pollSession;
      this.$refs.qrDialog.show(
        data.authUrl,
        this.form.representativeName,
        this.form.representativeIdNumber
      );
      this.pollTimer = setInterval(() => {
        this.$api
          .getCompanyAuthTask({ taskUuid: data.taskUuid })
          .then(({ data: { success } }) => {
            if (pollSession !== this.pollSession || this.pageDisposed) {
              return;
            }
            if (success) {
              this.stopPolling();
              this.$refs.qrDialog.hidden();
              this.showSuccess();
              this.$store.dispatch("user/getAccount");
            }
          });
      }, 1000);
    },
    showSuccess() {
      this.step = 3;
      this.setServicepopupvisible({ visible: true, type: 2 });
    },
    // 提交
    async postAccountAuth() {
      if (this.loading || this.pollTimer) {
        return;
      }
      this.loading = true;
      let parm = {};
      if (!this.showinviteCode) {
        const { inviteCode, ...par } = this.form;
        parm = par;
      } else {
        parm = this.form;
      }
      try {
        const { status, info, data } = await this.$api.postAccountCompanyAuth(parm);
        if (this.pageDisposed) {
          return;
        }
        if (status == 200) {
          this.$message({
            type: "success",
            message: info,
          });
          this.showQR(data);
        } else {
          this.$message({
            type: "error",
            message: info,
          });
        }
      } catch (error) {
        if (!this.pageDisposed) {
          this.$message({
            type: "error",
            message: (error && error.message) || "提交失败，请稍后重试",
          });
        }
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.stopPolling();
    },
    stopPolling() {
      this.pollSession += 1;
      if (this.pollTimer !== null) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    async onChange(file) {
      const { data } = await this.$api.getFileSts();
      const response = await uploadFile(file.raw, data, "znsign/avatar");
      if (response.res.status !== 200) {
        this.$message({
          type: "error",
          message: "上传失败，请联系管理员",
        });
        return;
      }
      const avatarRes = await this.$api.getCompanyOcr({
        imageUrl: this.$oss + response.name,
      });
      if (avatarRes.status !== 200) {
        this.$message({
          type: "error",
          message: avatarRes.info,
        });
        return;
      }
      if (avatarRes.data.error_code !== 0) {
        this.$message({
          type: "error",
          message: avatarRes.data.reason,
        });
        return;
      }
      this.form = {
        ...this.form,
        name: avatarRes.data.result.name,
        idNumber: avatarRes.data.result.creditcode,
        representativeName: avatarRes.data.result.person,
      };
      this.$refs.form.clearValidate();
      this.$message({
        type: "success",
        message: avatarRes.data.reason,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.CompanyAuth {
  @include contentStyle2;
  flex-direction: column;
  width: 1200px;
  margin: 0 auto;
  .daohang {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &_l {
      display: flex;
      .l_1 {
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-weight: 350;
        line-height: normal;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #999999;
      }
      .l_2 {
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-weight: 350;
        line-height: normal;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #999999;
        margin: 0 10px;
      }
      .l_3 {
        font-family: "Noto Sans SC";
        font-size: 16px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #262626;
      }
    }
    &_r {
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #262626;
    }
  }
  .top {
    background: #fff;
    height: 40px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    gap: 7.5px;
    font-size: 12px;
    img {
      width: 10.5px;
      height: 13px;
    }
  }

  .content {
    background: #ffffff;
    border-radius: 4px;
    padding-bottom: 60px;
    .CompanyAuth {
      width: 444px;
      height: 220px;
      background: url("~@/assets/image/CompanyAuth.webp") no-repeat;

      background-size: 444px auto;
      cursor: pointer;
    }
    &::v-deep .el-upload-dragger {
      width: 444px;
      height: 220px;
    }
    .title {
      line-height: 60px;
      text-align: center;

      font-family: "Noto Sans SC";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      color: #262626;
    }
    .titleDesc {
      font-size: 14px;
      font-weight: 350;
      /* 您也可 */
      color: #666666;
      text-align: center;
      line-height: 1.5;
      margin-bottom: 24px;
      span {
        cursor: pointer;
      }
    }
    .btns {
      display: flex;
      // align-items: center;
      justify-content: center;
      margin-top: 20px;
      .btn {
        @include buttonStyle;
      }
    }

    .step1 {
      width: 444px;
      margin: 0 auto;
      @include formStyle;
    }

    .step2 {
      display: flex;
      flex-direction: column;
      align-items: center;

      .dec {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        margin-top: 19px;
      }
    }
    .step3 {
      padding-top: 48px;
      &_icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        &_title {
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-weight: 500;
          line-height: 22px;

          font-variation-settings: "opsz" auto;
          color: #1d2129;
          margin-top: 16px;
        }
        &_desc {
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-weight: normal;
          line-height: 22px;
          letter-spacing: 0px;

          color: #86909c;
        }
        img {
          width: 48px;
          height: 48px;
        }
      }
    }
  }
}
</style>
